// Lógica de negocio del orquestador de plantillas (report-templates.vue), separada de la vista.
// Deriva el estado "en uso" de la galería a partir del config cargado y etiqueta páginas.
import { isModifiedFrom } from '../../report-page-builder/services/page-builder.converge'
import { discName, TYPES } from '../../report-page-builder/data/page-builder.render'

// Etiqueta visible de una página (la disciplina muestra su nombre de sección).
export function pageLabel(page) {
  if (page.type === 'discipline') return (page.settings && page.settings.name) || discName(page.settings && page.settings.discipline)
  return (TYPES[page.type] && TYPES[page.type].name) || page.type
}

// Estado "en uso" de la galería derivado del config cargado (builder = detailedToBuilder):
// - plantilla con nombre (templateKey) → activeKey + activeModified
// - copia de otro proyecto (importedFrom) → importedFrom + importedChips
// - config sin etiqueta → customInUse + customChips
function visibleLabels(builder) {
  return (builder && builder.pages ? builder.pages : []).filter((p) => p.visible !== false).map(pageLabel)
}

export function deriveActiveState(builder) {
  const templateKey = builder && builder.templateKey ? builder.templateKey : null
  const importedFrom = (builder && builder.importedFrom) || null
  const hasContent = !!(builder && Array.isArray(builder.pages) && builder.pages.length)
  // "Personalizada en uso": config con contenido que NO es una plantilla con nombre ni una
  // copia de otro proyecto. Dos orígenes:
  //  - legacy/editor antiguo: sin templateKey (ignis, naduri…).
  //  - guardada desde el Constructor: templateKey === 'custom' (la card Personalizada), que
  //    NO es una de las cards de plantilla (templatesArr filtra 'custom') → debe marcarse aquí.
  const customInUse = hasContent && !importedFrom && (!templateKey || templateKey === 'custom')

  return {
    // 'custom' no tiene card de plantilla propia (es la card Personalizada) → activeKey null.
    activeKey: templateKey === 'custom' ? null : templateKey,
    activeModified: templateKey && templateKey !== 'custom' ? isModifiedFrom(builder.pages || [], templateKey) : false,
    importedFrom,
    importedChips: importedFrom ? visibleLabels(builder) : [],
    customInUse,
    customChips: customInUse ? visibleLabels(builder) : [],
  }
}
